const config = {
  backendBaseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
  privacyPolicyUrl: 'https://xpress.delivery/polityka-prywatnosci',
  gdprPolicyPdf: '/rodo',
  defaultReportDateRangeMonths: 1,
  defaultIBANCountry: 'PL',
};

export default config;
